// Lib
import { curry, add, subtract, multiply, mapValues, round, ceil } from 'lodash/fp';

// Utils
import combine from '../../utils/lib/combine';

export const translate = combine(add);
export const difference = combine(subtract);

export const scale = curry((multiplier, multiplicandObj) => mapValues(multiply(multiplier), multiplicandObj));
export const reverseScale = curry((multiplier, multiplicandObj) =>
    mapValues(multiply(1 / multiplier), multiplicandObj),
);

export const roundVals = mapValues(round);
export const roundUpVals = mapValues(ceil);
